import { useCallback, useEffect, useState } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { deleteAllRecentSearches } from '@user/store/globalSearch'

export const UseDeleteRecentSearches = () => {
  const dispatch = useAppDispatch()

  const [deleteRecords, setDelete] = useState<boolean>(false)
  const [status, setStatus] = useState<'idle' | 'pending' | 'success' | 'fail'>(
    'idle',
  )

  const executeDelete = useCallback(() => {
    if (status != 'pending') setDelete(true)
  }, [status])

  useEffect(() => {
    let mounted = true

    if (deleteRecords) {
      const execute = async () => {
        try {
          await dispatch(deleteAllRecentSearches())

          if (mounted) {
            setStatus('success')
          }
        } catch (error) {
          if (mounted) {
            setStatus('fail')
          }
        } finally {
          setDelete(false)
        }
      }
      execute()
    }

    return () => {
      mounted = false
    }
  }, [dispatch, deleteRecords])

  return executeDelete
}
